<template>
  <!-- 物流工作台 -->
  <div class="logistic-work-bench">
    <div class="work-bench-top">
      <div class="work-bench-left-top">
        <div class="work-bench-echart">
          <div style="display: flex; justify-content: space-between;">
              <div>
                <span class="overview-title">昨日期末库存概览</span>
              </div>
              <div class="refreshDate">
                <Icon style="vertical-align: baseline;" type="md-alarm" />
                <span>更新时间：{{newTime}}</span>
                <span style="margin-left: 10px; color: #3C8DBC; cursor: pointer;" @click="getList">刷新</span>
              </div>
          </div>
          <div class="endingInventoryDate">
            <ul class="manage-left">
              <li v-for="(item,index) in endingInventoryDataList" :key="index">
                <span>{{item.value}}</span>
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
              </li>
            </ul>
          </div>
          <div id="main" style="width: 100%; height: 260px; margin-top: 20px"></div>
          <div class="fromLoading" v-show="finalInventoryLoading">
            <Spin></Spin>
          </div>
        </div>
      </div>
      <div class="work-bench-right-top">
        <div class="selectDateR">
          <Select v-model="warehouse" multiple multipleType @on-change="onchange" @on-open-change="warehouseChange" transfer chooseAll>
            <Option v-for="(item,index) in option" :key="index" :value="item.ID">{{item.NAME}}</Option>
          </Select>
        </div>
        <div class="selectWarehouseDate">
          <div class = "selectDateToday">
            <Icon class="caption-icon" type="md-calendar" />
            <span class="caption">今日数据</span>
            <ul class="manage-left">
              <li v-for="(item,index) in warehouseTodayDataList" :key="index">
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
                <span @click="jumpOrderClick(item.key, item.value)">{{item.value}}</span>
                <hr style="border:0;background-color:#E4E4E4;height:1px;margin-top: 5px">
              </li>
            </ul>
          </div>
          <div class = "selectDateYesterday">
            <Icon class="caption-icon" type="md-copy" />
            <span class="caption">昨日数据</span>
            <ul class="manage-right">
              <li v-for="(item,index) in warehouseYesetdayDataList" :key="index">
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
                <span @click="jumpYesterdayClick(item.key, item.value)">{{item.value}}</span>
                <hr style="border:0;background-color:#E4E4E4;height:1px;margin-top: 5px">
              </li>
            </ul>
          </div>
          <div class="fromLoading" v-show="warehouseLoading">
            <Spin></Spin>
          </div>
        </div>
      </div>
    </div>
    <div class="work-bench-bottom">
      <div class="work-bench-bottom-today">
        <span class="overview-title">今日仓库发货情况</span>
        <define-echart :id="'sendLogisticData'" :option="sendLogisticData" class="pie-top"></define-echart>
        <div style="display: flex;align-items:flex-end;">
          <define-echart :id="'stockBarContainer'" :option="stockBarData" class="bar-chart"></define-echart>
          <div>
            <ul class="send-logistic-total">
              <li v-for="(item,index) in sendTotalToday" :key="index">
                <span style="color: #fd6442;">{{item.value}}</span>
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
              </li>
            </ul>
            <ul class="send-logistic-total">
              <li v-for="(item,index) in sendTotalYesteday" :key="index">
                <span style="color: #39b0f9;">{{item.value}}</span>
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="fromLoading" v-show="sendLogisticLoading">
          <Spin></Spin>
        </div>
      </div>
      <div class="work-bench-bottom-today">
        <span class="overview-title">今日快递发货情况</span>
        <define-echart :id="'logisticsData'" :option="logisticsData" class="pie-top"></define-echart>
        <div style="display: flex;align-items:flex-end;">
          <define-echart :id="'logisticsBarContainer'" :option="logisticsBarData" class="bar-chart"></define-echart>
          <div>
            <ul class="send-logistic-total">
              <li v-for="(item,index) in sendLogisticsTotalToday" :key="index">
                <span style="color: #fd6442;">{{item.value}}</span>
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
              </li>
            </ul>
            <ul class="send-logistic-total">
              <li v-for="(item,index) in sendLogisticsTotalYesteday" :key="index">
                <span style="color: #39b0f9;">{{item.value}}</span>
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="fromLoading" v-show="logisticsLoading">
          <Spin></Spin>
        </div>
      </div>
      <div class="work-bench-bottom-right">
        <info-list :info="publicInfo"></info-list>
      </div>
    </div>

  </div>
</template>
<script>
import publicMethods from "commonJs/publicMethods";
import dateUtil from "commonJs/date.js";
import defineEchart from "commonCrumb/workBench/defineEchart.vue";
import infoList from "commonCrumb/workBench/infoList.vue";

  export default {
    components: {
      infoList,
      defineEchart
    },
    data() {
      return {
        warehouse: [], // 选择的仓库
        option: [],
        timeArr: [], // 选择的时间
        newTime: '',
        warehourseId:'',
        finalInventoryLoading: false,
        isShowFromLoading: false,
        sendLogisticLoading: false,
        logisticsLoading: false,
        warehouseLoading:false,
        setTimeout: null,
        optionEchart: {
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['长锦仓', '万翔仓', '万翔东纶仓', '福盈仓', '顺丰武汉仓', '中通晋江仓', '菜鸟华北仓', '菜鸟华东仓', '菜鸟华中仓', '菜鸟西南仓', '菜鸟华南仓'],
            axisLabel:{
              show:true,
              interval:0,
            }
          },
          tooltip : {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#fd6442'
              }
            }
          },
          legend: {
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: [],
            // name:'邮件营销',
            type:'line',
            stack: '总量',
            areaStyle: {},
          }],
          color: '#fd6442'
        },
        //今日仓库发货情况
        sendLogisticData: {
          title: {
          },
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            right: "0px",
            bottom: "0px",
            type: "scroll",
            height: "150px",
            orient: "vertical",
            data: []
          },
          series: [
            {
              name: "今日发货比例",
              type: "pie",
              radius: "55%",
              center: ["40%", "50%"],
              label: { normal: { show: true, formatter: "{b} : ({d}%)" } },
              data: [
              ],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                },
                normal:{
                  color:function(params) {
                    //自定义颜色
                    let colorList = [
                      '#39B0F9', '#FF7C4D', '#50D27C', '#B3A2C7', '#4198AF', '#DB843D'];
                    return colorList[params.dataIndex]
                  }
                }
              }
            }
          ]
        },
        //今日快递比例饼图数据
        logisticsData: {
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            right: "0px",
            orient: "vertical",
            data: []
          },
          series: [
            {
              name: "今日快递比例",
              type: "pie",
              radius: "55%",
              center: ["40%", "50%"],
              label: { normal: { show: true, formatter: "{b} : ({d}%)" } },
              data: [
              ],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                },
                normal:{
                  color:function(params) {
                    //自定义颜色
                    let colorList = [
                      '#39B0F9', '#FF7C4D', '#50D27C', '#B3A2C7', '#4198AF', '#DB843D'];
                    return colorList[params.dataIndex]
                  }
                }
              }
            }
          ]
        },
        stockBarData: {
          title: {
            textStyle: {
              color: "#ff7c4d",
              fontSize: 14,
              fontWeight: "bold"
            }
          },
          tooltip: {},
          xAxis: {   //x轴的配置信息
            type: "category",
            data: [
              "长锦仓",
              "万翔仓",
              "中通晋江仓",
              "福盈仓",
              "顺丰武汉仓",
              "菜鸟"
            ],
            axisLabel: { //设置x轴的文字倾斜并且全部显示
              //设置x轴全都显示
              rotate: 30,
              interval: 0,
              textStyle: {
                color: '#111',
                fontSize:12
              }
            },
            nameTextStyle:{
              fontSize: 12
            }
          },
          legend: {
          },
          yAxis: {
          },
          series: [
            {
              name: "今日发货单量",
              type: "bar",
              data: [],
              itemStyle: {
                normal: {
                  color: "#ff7c4d", //设置柱条的颜色
                  label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}\n',
                    rotate: 30,
                    fontSize:"10"
                  }
                }
              }
            },
            {
              name: "昨日发货单量",
              type: "bar",
              data: [],
              itemStyle: {
                normal: {
                  color: "#39b0f9", //设置柱条的颜色
                  label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}\n',
                    rotate: 30,
                    fontSize:"10"
                  }
                }
              }
            }
          ]
        },
        logisticsBarData: {
          title: {
            textStyle: {
              color: "#ff7c4d",
              fontSize: 14,
              fontWeight: "bold"
            }
          },
          tooltip: {
            formatter:'{c}'
          },
          xAxis: {   //x轴的配置信息
            type: "category",
            data: [
              "中通",
              "韵达",
              "圆通",
              "京东",
              "顺丰",
              "其他"
            ],
            axisLabel: { //设置x轴的文字倾斜并且全部显示
              //设置x轴全都显示
              rotate: 30,
              interval: 0,
              textStyle: {
                color: '#111',
                fontSize:12
              }
            },
            nameTextStyle:{
              fontSize: 12
            }
          },
          legend: {
          },
          yAxis: {
          },
          series: [
            {
              name: "今日发货单量",
              type: "bar",
              data: [],
              itemStyle: {
                normal: {
                  color: "#ff7c4d", //设置柱条的颜色
                  label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}\n',
                    rotate: 30,
                    fontSize:"10"
                  }
                }
              }
            },
            {
              name: "昨日发货单量",
              type: "bar",
              data: [],
              itemStyle: {
                normal: {
                  color: "#39b0f9",
                  label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}\n',
                    rotate: 30,
                    fontSize:"10"
                  }
                }
              }
            }
          ]
        },
        publicInfo: {
          icon: "ios-megaphone",
          size: "30",
          color: "",
          custom: "",
          title: "物流方案概览",
          width: "100%",
          height: "100%",
          toTable: 'PM_C_PROM_ACTI',
          name: 'logisticWorkbench',
          infos: []
        },
        endingInventoryDataList: [
          {
            value: '0',
            key: 'INVENTORY_TOTAL',
            name: '库存总计',
          }
        ],
        sendTotalToday: [
          {
            value: '0',
            key: 'TODAY',
            name: '今日发货单量',
          }
        ],
        sendTotalYesteday: [
          {
            value: '0',
            key: 'YESTERDAY',
            name: '昨日发货单量',
          }
        ],
        sendLogisticsTotalToday: [
          {
            value: '0',
            key: 'TODAY',
            name: '今日发货单量',
          }
        ],
        sendLogisticsTotalYesteday: [
          {
            value: '0',
            key: 'YESTERDAY',
            name: '昨日发货单量',
          }
        ],
        warehouseTodayDataList: [
          {
            value: '0',
            key: 'TODAY_ORDER',
            name: '今日商城下单',
          },{
            value: '0',
            key: 'TODAY_SEND_WAREHOUSE',
            name: '今日推送仓库',
          },{
            value: '0',
            key: 'TODAY_OUT_WAREHOUSE',
            name: '今日仓库出库',
          },{
            value: '0',
            key: 'TODAY_SEND_PLATFORM',
            name: '今日平台发货',
          },{
            value: '0',
            key: 'TODAY_SENDED_WARES',
            name: '今日已发商品',
          }
        ],
        warehouseYesetdayDataList: [
          {
            value: '0',
            key: 'YESTERDAY_SEND_ORDER',
            name: '昨日已发订单',
          },{
            value: '0',
            key: 'YESTERDAY_SENDED_WARES',
            name: '昨日已发商品',
          },{
            value: '0',
            key: 'YESTERDAY_WAREHOUSE_UNBILLED',
            name: '昨日仓库未发订单',
          },{
            value: '0',
            key: 'YESTERDAY_RETURN_SCAN_IN',
            name: '昨日退货订单—扫描入库',
          },{
            value: '0',
            key: 'YESTERDAY_RETURN_ORDER_BACK',
            name: '昨日退货订单—原单退回',
          }
        ],
      };
    },
    methods: {
      //选择店仓
      onchange(val) {
        this.warehouse = val;
      },
      warehouseChange(val) {
        if (!val) {
          if (!this.warehouse.length){
            this.warehouse.push(this.warehouseId);
          }
          this.queryTodayOrYesterdayList(this.warehouse);
        }
      },
      // 获取页面
      getList() {
        const _this = this;
        window.clearTimeout(_this.setTimeout);
        _this.setTimeout = null;
        _this.queryFinalInventoryList();
        _this.queryTodayDeliverySendList();
        _this.queryTodayOrYesterdayList(_this.warehouse);
        _this.queryTodayWarehouseSendList();
        _this.setTimeout = setInterval(() => {
          this.getList();
        }, 60000 * 5);
        this.newTime = publicMethods.DatesTime(new Date());
      },
      // 获取活动列表
      getExpress() {
        const _this = this;
        let fromdata = new FormData();
        fromdata.append("param", JSON.stringify({}));
        axios({
          url: "/p/cs/expressQueryService",
          method: "post",
          data: fromdata
        }).then(res => {
          if (res.data.code === 0) {
            _this.publicInfo.infos = res.data.data;
          }
        });
      },
      queryStore() {
        //获取店仓数据
        let self = this;
        axios({
          url: "/p/cs/getWarehourseByAll",
          method: "post",
          data: {}
        }).then(res => {
          if (res.data.code === 0) {
            self.option = res.data.data;
            self.warehourseId = self.option[0].ID;
            self.option.map(optionItem=>{
              self.warehouse.push(optionItem.ID)
            });
            // self.warehouse.push(self.option[0].ID);
            self.getList();
          } else {
            self.$Message.error(res.data.message);
          }
        });
      },
      // 跳转订单页面 param: JSON.stringify({id: 1,type:2})
      jumpOrderClick(key, total) {
        if (total !== 0){
          let param = [{"type": "Select","queryName": "CP_C_PHY_WAREHOUSE_ID","value": this.warehouse.join(',')}];
          let label = [];
          let currentDate =  new Date();
          this.timeArr[0] = dateUtil.getFormatDate(currentDate,'yyyy-MM-dd') + " 00:00:00";
          this.timeArr[1] = this.newTime;
          if (key === 'TODAY_ORDER') {
            param = param.concat([
              {"type": "date","queryName": "PAY_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
              {"type": "Select","queryName": "ORDER_STATUS","value": '1,2,3'}
            ]);
            label = [
              {
                "val": "!=手工新增",
                "text": "手",
                "sort": 7,
                "key": "ORDER_SOURCE"
              }, {
                "val": "!=2",
                "text": "换",
                "sort": 6,
                "key": "ORDER_TYPE"
              }
            ];
            this.selectOrders(key, param, label);
          }else if(key === 'TODAY_SEND_WAREHOUSE'){
            param = param.concat([
              {"type": "date","queryName": "DISTRIBUTION_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
              {"type": "Select","queryName": "ORDER_STATUS","value": '4'}
            ]);
            this.selectOrders(key, param, label);
          }else if(key === 'TODAY_OUT_WAREHOUSE'){
            param = param.concat([
              {"type": "date","queryName": "SCAN_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
              {"type": "Select","queryName": "ORDER_STATUS","value": '5'}
            ]);
            this.selectOrders(key, param, label);
          }else if(key === 'TODAY_SEND_PLATFORM'){
            param = param.concat([
              {"type": "date","queryName": "SCAN_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
              {"type": "Select","queryName": "ORDER_STATUS","value": '6'}
            ]);
            this.selectOrders(key, param, label);
          }else if(key === 'TODAY_SENDED_WARES'){
            param = param.concat([
              {"type": "date","queryName": "SCAN_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
              {"type": "Select","queryName": "ORDER_STATUS","value": '5,6'}
            ]);
            this.selectOrders(key, param, label);
          }
        }
      },
      jumpYesterdayClick(key, total) {
        if (total !== 0){
          let param = [{"type": "Select","queryName": "CP_C_PHY_WAREHOUSE_ID","value": this.warehouse.join(',')}];
          let label = [];
          let returnParam = {};
          let currentDate =  new Date();
          let preDate = new Date((currentDate.getTime()-24*60*60*1000));
          this.timeArr[0] = dateUtil.getFormatDate(preDate,'yyyy-MM-dd') + " 00:00:00";
          this.timeArr[1] = dateUtil.getFormatDate(preDate,'yyyy-MM-dd') + " 23:59:59";
          if (key === 'YESTERDAY_SEND_ORDER') {
            param = param.concat([
              {"type": "date","queryName": "SCAN_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
              {"type": "Select","queryName": "ORDER_STATUS","value": '5,6'}
            ]);
            this.selectOrders(key, param, label);
          }else if(key === 'YESTERDAY_SENDED_WARES'){
            param = param.concat([
              {"type": "date","queryName": "SCAN_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
              {"type": "Select","queryName": "ORDER_STATUS","value": '5,6'}
            ]);
            this.selectOrders(key, param, label);
          }else if(key === 'YESTERDAY_WAREHOUSE_UNBILLED'){
            this.getOrderIdListByWarehouse(key);
          }else if(key === 'YESTERDAY_RETURN_SCAN_IN'){
            returnParam = {
              time: 'IN_TIME',
              startTime: this.timeArr[0],
              endTime: this.timeArr[1],
              returnStatus: ['30','50'],
              // IS_ACTIVE: 'Y',
              CP_C_PHY_WAREHOUSE_ID: this.warehouse.join(','),
              IS_BACK:'0'
            };
            this.selectReturnOrders(returnParam);
          }else if(key === 'YESTERDAY_RETURN_ORDER_BACK'){
            returnParam = {
              time: 'IN_TIME',
              startTime: this.timeArr[0],
              endTime: this.timeArr[1],
              returnStatus:  ['30','50'],
              // IS_ACTIVE: 'Y',
              CP_C_PHY_WAREHOUSE_ID: this.warehouse.join(','),
              IS_BACK:'1'
            };
            this.selectReturnOrders(returnParam);
          }
        }
      },
      getOrderIdListByWarehouse(type){
        const _this = this;
        let fromdata = new FormData();
        let param = {
          WAREHOUSE_ID: _this.warehouse,
          TYPE: type
        };
        fromdata.append("param", JSON.stringify(param));
        axios({
          url: "/p/cs/todayOrYesterdaySearch",
          method: "post",
          data: fromdata
        }).then(res => {
          if (res.data.code === 0) {
            let orderIds = res.data.data.value;
            if(orderIds.length !== 0){
              _this.$store.commit("TabOpen", {
                id: 2627, //单据id
                type: "action", //类型action
                name: "orderManager", //文件名
                label: "订单管理", //tab中文名
                query: {
                  id: 2627, //单据id
                  tabTitle: "订单管理", //tab中文名
                  type: 'workID',
                  ID: orderIds
                }
              });
            }
          }
        });
      },
      selectOrders(type, params, labeldata) {
        const _this = this;
        _this.isShowFromLoading = true;
        this.$store.commit("TabOpen", {
          id: 2627, //单据id
          type: "action", //类型action
          name: "orderManager", //文件名
          label: "订单管理", //tab中文名
          query: {
            id: 2627, //单据id
            tabTitle: "订单管理", //tab中文名
            type: 'workID',
            param: JSON.stringify(params),
            label: JSON.stringify(labeldata)
          }
        });
        _this.isShowFromLoading = false;
      },
      selectReturnOrders(returnParam) {
        const _this = this;
        _this.isShowFromLoading = true;
        this.$store.commit("TabOpen", {
          id: 2661, //单据id
          type: "action", //类型action
          name: "returngoodList", //文件名
          label: "退换货订单", //tab中文名
          query: {
            id: 2661, //单据id
            tabTitle: "退换货订单", //tab中文名
            type: 'workID',
            returnParam: JSON.stringify(returnParam)
          }
        });
        _this.isShowFromLoading = false;
      },
      // 获取昨日期末库存概览页面数据
      queryFinalInventoryList() {
        const _this = this;
        _this.finalInventoryLoading = true;
        let fromdata = new FormData();
        let param = {
        };
        fromdata.append("param", JSON.stringify(param));
        axios({
          url: "/p/cs/yesterdayEndingInventorySearch",
          method: "post",
          data: fromdata
        }).then(res => {
          if (res.data.code === 0) {
            const item = res.data.data;
            _this.finalInventoryLoading = false;
            this.newTime = publicMethods.DatesTime(new Date());
            let exhartArr = [];
            item.forEach((item, index) => {
              if (item.key === 'CJC'){//长锦仓
                exhartArr[0] = item.value;
              } else if (item.key === '6008'){//万翔仓
                exhartArr[1] = item.value;
              } else if (item.key === 'WXDLC'){//万翔东纶仓
                exhartArr[2] = item.value;
              } else if (item.key === 'FYC'){//福盈仓
                exhartArr[3] = item.value;
              } else if (item.key === 'SHWHC'){//顺丰武汉仓
                exhartArr[4] = item.value;
              } else if (item.key === 'ZTJJC'){//中通晋江仓
                exhartArr[5] = item.value;
              } else if (item.key === 'CNHBC'){//菜鸟华北仓
                exhartArr[6] = item.value;
              } else if (item.key === 'CNHDC'){//菜鸟华东仓
                exhartArr[7] = item.value;
              } else if (item.key === 'CNHZC'){//菜鸟华中仓
                exhartArr[8] = item.value;
              } else if(item.key === 'CNXNC'){//菜鸟西南仓
                exhartArr[9] = item.value;
              } else if(item.key === 'CNHNC') {//菜鸟华南仓
                exhartArr[10] = item.value;
              } else if (item.key === 'INVENTORY_TOTAL'){//库存总计
                // _this.endingInventoryDataList[0].value = item.value;
                _this.endingInventoryDataList[0].value = 2210;
              }
            });
            // _this.optionEchart.series[0].data = exhartArr; // 昨日期末库存概览
            _this.optionEchart.series[0].data = [120,140,200,100,210,260,220,210,300,260,190]; // 昨日期末库存概览
            let myChart = echarts.init(document.getElementById('main'));
            myChart.setOption(this.optionEchart);
          }
        });
      },
      //获取昨日今日数据
      queryTodayOrYesterdayList(warehouse) {
        const _this = this;
        _this.warehouseLoading = true;
        let fromdata = new FormData();
        let param = {
          WAREHOUSE_ID: warehouse,
        };
        fromdata.append("param", JSON.stringify(param));
        axios({
          url: "/p/cs/todayOrYesterdaySearch",
          method: "post",
          data: fromdata
        }).then(res => {
          if (res.data.code === 0) {
            _this.warehouseLoading = false;
            let todayData = res.data.data.TODAY;
            let yesterdayData = res.data.data.YESTERDAY;
            _this.warehouseTodayDataList = publicMethods.workArrHeavy(_this.warehouseTodayDataList, todayData);
            _this.warehouseYesetdayDataList = publicMethods.workArrHeavy(_this.warehouseYesetdayDataList, yesterdayData);
          }
        });
      },
      //获取今日快递发货情况
      queryTodayDeliverySendList() {
        const _this = this;
        _this.logisticsLoading = true;
        let fromdata = new FormData();
        let param = {
        };
        fromdata.append("param", JSON.stringify(param));
        axios({
          url: "/p/cs/todayDeliverySendSearch",
          method: "post",
          data: fromdata
        }).then(res => {
          if (res.data.code === 0) {
            _this.logisticsLoading = false;
            //快递发货
            let todaySendnumData = res.data.data.SEND_NUM.TODAY;
            let yesterdaySendnumData = res.data.data.SEND_NUM.YESTERDAY;
            let todayTotal = res.data.data.SEND_TOT_NUM.TODAY;
            let yesterdayTotal = res.data.data.SEND_TOT_NUM.YESTERDAY;

            let yundaTodayNum = todaySendnumData.YUNDA;
            let ztoTodayNum = todaySendnumData.ZTO;
            let ytoTodayNum = todaySendnumData.YTO;
            let jdTodayNum = todaySendnumData.JD;
            let sftcTodayNum = todaySendnumData.SFTC;
            let otherTodayNum = todaySendnumData.OTHER;

            let yundaYesterdayNum = yesterdaySendnumData.YUNDA;
            let ztoYesterdayNum = yesterdaySendnumData.ZTO;
            let ytoYesterdayNum = yesterdaySendnumData.YTO;
            let jdYesterdayNum = yesterdaySendnumData.JD;
            let sftcYesterdayNum = yesterdaySendnumData.SFTC;
            let otherYesterdayNum = yesterdaySendnumData.OTHER;
            _this.logisticsData.series[0].data =  [
              { value: ztoTodayNum, name: "中通快递" },
              { value: yundaTodayNum, name: "韵达快递" },
              { value: ytoTodayNum, name: "圆通速递" },
              { value: jdTodayNum, name: "京东" },
              { value: sftcTodayNum, name: "顺丰" },
              { value: otherTodayNum, name: "其他" }
            ];
            _this.logisticsBarData.series[0].data =  [
              ztoTodayNum,yundaTodayNum,ytoTodayNum,jdTodayNum,sftcTodayNum,otherTodayNum
            ];
            _this.logisticsBarData.series[1].data =  [
              ztoYesterdayNum,yundaYesterdayNum,ytoYesterdayNum,jdYesterdayNum,sftcYesterdayNum,otherYesterdayNum
            ];
            _this.sendLogisticsTotalToday[0].value = todayTotal;
            _this.sendLogisticsTotalYesteday[0].value = yesterdayTotal;
            let myChart = echarts.init(document.getElementById('logisticsData'));
            myChart.setOption(_this.logisticsData);
            let myColumnarChart = echarts.init(document.getElementById('logisticsBarContainer'));
            myColumnarChart.setOption(_this.logisticsBarData);
          }
        });
      },
      //获取今日仓库发货情况
      queryTodayWarehouseSendList() {
        const _this = this;
        _this.sendLogisticLoading = true;
        let fromdata = new FormData();
        let param = {
        };
        fromdata.append("param", JSON.stringify(param));
        axios({
          url: "/p/cs/todayWarehouseSendSearch",
          method: "post",
          data: fromdata
        }).then(res => {
          if (res.data.code === 0) {
            _this.sendLogisticLoading = false;
            //快递发货
            let todaySendnumData = res.data.data.SEND_NUM.TODAY;
            let yesterdaySendnumData = res.data.data.SEND_NUM.YESTERDAY;
            let wxcTodayNum = todaySendnumData.WXC;
            let fycTodayNum = todaySendnumData.FYC;
            let ztjjcTodayNum = todaySendnumData.ZTJJC;
            let cnhncTodayNum = todaySendnumData.CNHNC;
            let cjcTodayNum = todaySendnumData.CJC;
            let shwhcTodayNum = todaySendnumData.SHWHC;
            let wxcYesterdayNum = yesterdaySendnumData.WXC;
            let fycYesterdayNum = yesterdaySendnumData.FYC;
            let ztjjcYesterdayNum = yesterdaySendnumData.ZTJJC;
            let cnhncYesterdayNum = yesterdaySendnumData.CNHNC;
            let cjcYesterdayNum = yesterdaySendnumData.CJC;
            let shwhcYesterdayNum = yesterdaySendnumData.SHWHC;
            let todayTotal = res.data.data.SEND_TOT_NUM.TODAY;
            let yesterdayTotal = res.data.data.SEND_TOT_NUM.YESTERDAY;
            _this.sendLogisticData.series[0].data =  [
              { value: cjcTodayNum, name: "长锦仓" },
              { value: wxcTodayNum, name: "万翔仓" },
              { value: ztjjcTodayNum, name: "中通晋江仓" },
              { value: fycTodayNum, name: "福盈仓" },
              { value: shwhcTodayNum, name: "顺丰武汉仓" },
              { value: cnhncTodayNum, name: "菜鸟" }
            ];
            _this.stockBarData.series[0].data =  [
              cjcTodayNum,wxcTodayNum,ztjjcTodayNum,fycTodayNum,shwhcTodayNum,cnhncTodayNum
            ];
            _this.stockBarData.series[1].data =  [
              cjcYesterdayNum,wxcYesterdayNum,ztjjcYesterdayNum,fycYesterdayNum,shwhcYesterdayNum,cnhncYesterdayNum
            ];
            _this.sendTotalToday[0].value = todayTotal;
            _this.sendTotalYesteday[0].value = yesterdayTotal;
            let myChart = echarts.init(document.getElementById('sendLogisticData'));
            myChart.setOption(_this.sendLogisticData);
            let myColumnarChart = echarts.init(document.getElementById('stockBarContainer'));
            myColumnarChart.setOption(_this.stockBarData);
          }
        });
      },
    },
    created() {},
    mounted() {
      let self = this;
      self.queryStore();
      self.getExpress();
    },
    beforeDestroy() {
      window.clearTimeout(this.setTimeout);
      this.setTimeout = null;
    }
  };
</script>
<style lang="less">
  .logistic-work-bench {
    padding: 8px 12px;
    position: relative;
    .work-bench-top{
      background: #fafafa;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      border-radius: 10px;
      .work-bench-left-top {
        width: 70%;
        .work-bench-echart {
          padding: 10px;
          position: relative;
          background: #fafafa;
          margin-top: 5px;
          border-radius: 10px;
          .endingInventoryDate{
            display: flex;
            margin-top: 20px;
            margin-left: 15px;
            .manage-left {
              width: 100%;
              height:10px;
              li {
                position: relative;
                display: inline-block;
                width: 10%;
                text-align: center;
                margin-bottom: 15px;
                span {
                  color: #fd6442;
                  font-size: 22px;
                  cursor: pointer;
                }
                span:hover {
                  font-weight: bold;
                }
                .manage-name {
                  display: block;
                  font-size: 14px;
                  line-height: 38px;
                  color: #999;
                  white-space:nowrap;
                }
              }
            }
          }
          .overview-title {
            color: #fd6442;
            margin-left: 3px;
            font-size: 16px;
            font-weight: bold;
            padding-top: 5px;
            padding-bottom: 5px;
            display: inline-block;
            border-bottom: 2px solid ;
          }
          .refreshDate {
            margin: 0 30px 0 0;
            color: #797979;
          }
          .fromLoading {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(255, 255, 255, 0.9);
            z-index: 1000 !important;
          }
        }
      }
      .work-bench-right-top {
        width: 30%;
        margin: 0 0 0 20px;
        background: #fafafa;
        padding-left: 10px;
        border-radius: 10px;
        .selectWarehouseDate{
          display: flex;
          margin-top: 8px;
          position: relative;
          .fromLoading {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(255, 255, 255, 0.9);
            z-index: 1000 !important;
          }
          .selectDateToday {
            color: #fd6442;
            font-size: 24px;
            width: 50%;
            .caption {
              margin-left: 3px;
              font-size: 16px;
              font-weight: bold;
              padding-top: 7px;
            }
            .caption-icon {
              margin-top: 5px;
            }
            .manage-left {
              width: 90%;
              margin-top: 30px;
              li {
                text-align: left;
                margin-bottom: 15px;
                margin-left: 15px;
                /*text-decoration : underline;*/
                span {
                  color: #fd6442;
                  font-size: 12px;
                  cursor: pointer;
                }
                .manage-name {
                  font-size: 12px;
                  color: #999;
                  white-space:nowrap;
                }
              }
            }
          }
          .selectDateYesterday {
            color: #39b0f9;
            font-size: 24px;
            width: 50%;
            .caption {
              margin-left: 3px;
              font-size: 16px;
              font-weight: bold;
              padding-top: 7px;
            }
            .caption-icon {
              margin-top: 5px;
            }
            .manage-right {
              width: 90%;
              margin-top: 30px;
              li {
                text-align: left;
                margin-bottom: 15px;
                margin-left: 15px;
                span {
                  color: #3C8DBC;
                  font-size: 12px;
                  cursor: pointer;
                }
                .manage-name {
                  font-size: 12px;
                  color: #999;
                  white-space: nowrap;
                }
              }
            }
          }
        }
        .selectDateR {
          margin-top: 5px;
          .ark-select {
            text-align: left;
            width: 200px;
          }
        }
      }
    }
    .work-bench-bottom{
      display: flex;
      display: -webkit-flex;
      width: 100%;
      .work-bench-bottom-today{
        width: 40%;
        margin: 20px 20px 0 0;
        background: #fafafa;
        padding: 10px;
        border-radius: 10px;
        position: relative;
        .work-bench-left-bottom {
          width: 48%;
          display:inline-block;
          position: relative;
          .fromLoading {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(255, 255, 255, 0.9);
            z-index: 1000 !important;
          }
        }
        .send-logistic-total {
          width: 100%;
          li {
            width: 10%;
            text-align: center;
            margin-bottom: 25px;
            span {
              font-size: 17px;
              cursor: pointer;
            }
            span:hover {
              font-weight: bold;
            }
            .manage-name {
              display: block;
              font-size: 7px;
              line-height: 38px;
              color: #999;
              white-space:nowrap;
            }
          }
        }
        .overview-title {
          color: #fd6442;
          margin-left: 3px;
          font-size: 16px;
          font-weight: bold;
          padding-top: 5px;
          padding-bottom: 5px;
          display: inline-block;
          border-bottom: 2px solid ;
          /*border-bottom: 3px solid ;*/
        }
        .pie-top {
          width: 100%;
          height: 280px;
        }
        .bar-chart {
          float: left;
          width: 80%;
          height: 220px;
        }
        .fromLoading {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(255, 255, 255, 0.9);
          z-index: 1000 !important;
        }
      }
      .work-bench-bottom-right {
        width: 20%;
        height: 538px;
        margin: 20px 0 0 0;
        background: #fafafa;
        padding: 5px 0 0 10px;
        border-radius: 10px;
      }
    }
  }
</style>


